import { transformReqBody } from '~/src/dash/api/headerbidders/headerbidders_methods';
import { ILiverampMarketplaceSegmentsListInfo } from '~/src/dash/api/liveramp-segments/liveramp_models';
import { createUrl, IHttpResponse, restGet, restPost } from '~/src/dash/api/rest';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IListItem, IMenuList } from '~/src/dash/types/menuList';

interface IHeaderLiverampQueries {
  [key: string]: any;
}

interface IProviderNames {
  provider_names: string[];
}

interface ISegmentTypes {
  segment_types: string[];
}

export interface ILiverampDistributionParams {
  urlQueries: IHeaderLiverampQueries;
}

export interface ILiverampMarketplaceSegmentListInfoWithCount {
  liveramp_marketplace_segments: ILiverampMarketplaceSegmentsListInfo[];
  total_count: number;
  PaginationToken: string;
}

// Transforms passed in queries and appends them to requestURL
function addUrlQueries(urlQueries: IHeaderLiverampQueries, reqUrl: string): string {
  for (const [key, value] of Object.entries(urlQueries)) {
    switch (key) {
      case 'page':
        reqUrl += '&page=' + String(value);
        break;
      case 'pageSize':
        reqUrl += '&page_size=' + String(value);
        break;
      case 'search':
        reqUrl += '&search=' + String(value);
        break;
      case 'orderBy':
        reqUrl += '&order_by=' + String(value);
        break;
      case 'orderDirection':
        reqUrl += '&order_direction=' + String(value);
        break;
      case 'Providers':
        reqUrl += '&providers=' + String(value);
        break;
      case 'segmentType':
        reqUrl += '&SegmentType=' + String(value);
        break;
      case 'useCases':
        reqUrl += '&useCases=' + String(value);
        break;
      case 'IsRequested':
        reqUrl += '&isRequested=' + String(value);
    }
  }
  return reqUrl;
}

export async function getLiverampMarketplaceSegments(
  publisherID: string,
  { urlQueries = {} }: ILiverampDistributionParams,
): Promise<[ILiverampMarketplaceSegmentListInfoWithCount | undefined, string | undefined]> {
  let reqUrl = createUrl('/get_liveramp_marketplace_segments', publisherID, 'v1');
  reqUrl = addUrlQueries(urlQueries, reqUrl);
  try {
    return [
      (await restGet<ILiverampMarketplaceSegmentListInfoWithCount>(reqUrl, transformReqBody({})))
        .parsedBody,
      undefined,
    ];
  } catch (e) {
    return [undefined, e];
  }
}

export async function requestLiverampMarketplaceSegments(
  requestBody: { [key: string]: any },
  publisherID: string,
): Promise<[IHttpResponse<{ success: boolean }>?, Error?]> {
  const reqUrl = createUrl('/request_liveramp_marketplace_segments', publisherID, 'v1');
  try {
    return [await restPost<{ success: boolean }>(reqUrl, requestBody), undefined];
  } catch (e) {
    return [undefined, e];
  }
}

// to get provider names for filter
export async function getProviderNames(session: ISessionState): Promise<Record<string, IMenuList>> {
  const publisherID = session.publisher.ID;
  const reqUrl = createUrl('/get_liveramp_provider_names', publisherID, 'v1');
  const providerNameList = {} as Record<string, IListItem>;
  try {
    const result = (await restGet<IProviderNames>(reqUrl, {})).parsedBody as IProviderNames;
    result.provider_names.forEach((ele) => {
      providerNameList[ele] = {
        ID: ele,
        title: ele,
        selected: false,
      };
    });
    return { Providers: providerNameList };
  } catch (e) {
    return { Providers: {} };
  }
}

// to get segment types for filter
export async function getSegmentTypes(session: ISessionState): Promise<Record<string, IMenuList>> {
  const publisherID = session.publisher.ID;
  const reqUrl = createUrl('/get_liveramp_segment_types', publisherID, 'v1');
  const segmentTypeList = {} as Record<string, IListItem>;
  try {
    const result = (await restGet<ISegmentTypes>(reqUrl, {})).parsedBody as ISegmentTypes;
    result.segment_types.forEach((ele) => {
      segmentTypeList[ele] = {
        ID: ele,
        title: ele,
        selected: false,
      };
    });
    return { 'Segment Type': segmentTypeList };
  } catch (e) {
    return { 'Segment Type': {} };
  }
}
